var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 18V37.5H4.5V18H37.5ZM39 13.5H3C1.35 13.5 0 14.85 0 16.5V39C0 40.65 1.35 42 3 42H39C40.65 42 42 40.65 42 39V16.5C42 14.85 40.65 13.5 39 13.5Z",
    fill: "#4FBBBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9H37.5C38.325 9 39 9.675 39 10.5C39 11.325 38.325 12 37.5 12H4.5C3.675 12 3 11.325 3 10.5C3 9.675 3.675 9 4.5 9Z",
    fill: "#4FBBBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5H33C33.825 4.5 34.5 5.175 34.5 6C34.5 6.825 33.825 7.5 33 7.5H9C8.175 7.5 7.5 6.825 7.5 6C7.5 5.175 8.175 4.5 9 4.5Z",
    fill: "#4FBBBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0H28.5C29.325 0 30 0.675 30 1.5C30 2.325 29.325 3 28.5 3H13.5C12.675 3 12 2.325 12 1.5C12 0.675 12.675 0 13.5 0Z",
    fill: "#4FBBBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.e78d6e4d841f8e3d06f7dde0aa2577b1.svg";
export { ForwardRef as ReactComponent };